
import { useState, useEffect, useCallback } from 'react';

const reviews = [
  {
    id: 1,
    name: '田中 美咲',
    country: '🇯🇵 東京',
    date: '2025年5月',
    rating: 5,
    title: '昭和の雰囲気に感動！',
    text: '古民家の雰囲気が最高でした。木の温もりと昭和レトロな調度品に囲まれて、日常を忘れられる特別な空間でした。ホストの方も親切で、チェックインもスムーズ。また必ず来ます！',
    stay: '2泊',
    avatar: 'M',
    avatarColor: '#8B2500',
  },
  {
    id: 2,
    name: 'Sarah K.',
    country: '🇺🇸 New York',
    date: '2025年5月',
    rating: 5,
    title: 'Absolutely magical experience!',
    text: '古民家に泊まるのは初めてでしたが、本当に素晴らしかったです。Traditional Japanese architecture with modern comforts. The host was incredibly helpful with local tips. Highly recommend!',
    stay: '3泊',
    avatar: 'S',
    avatarColor: '#c8504a',
  },
  {
    id: 3,
    name: '鈴木 健太',
    country: '🇯🇵 大阪',
    date: '2025年4月',
    rating: 5,
    title: 'Airbnbより断然お得！直接予約が正解',
    text: '以前Airbnbで予約したことがありましたが、今回は直接予約で約15%安く泊まれました。料金だけでなく、ホストと直接やり取りできるので融通も利いて最高です。チェックアウトも少し遅らせてもらえました。',
    stay: '4泊',
    avatar: 'K',
    avatarColor: '#6b3a1f',
  },
  {
    id: 4,
    name: 'Yuki T.',
    country: '🇫🇷 Paris',
    date: '2025年4月',
    rating: 5,
    title: 'Une expérience inoubliable à Tokyo',
    text: '東京の中心部にこんな素敵な古民家があるとは思いませんでした。静かで落ち着いた空間で、観光の疲れをしっかり癒せました。荷物預かりサービスも便利で、最終日も身軽に観光できました。',
    stay: '5泊',
    avatar: 'Y',
    avatarColor: '#9a5c2e',
  },
  {
    id: 5,
    name: '李 明',
    country: '🇨🇳 上海',
    date: '2025年3月',
    rating: 5,
    title: '日本の伝統文化を体験できる最高の宿',
    text: '日本の伝統的な建築と生活様式を体験できる貴重な宿です。プライベートドライバーサービスも利用しましたが、空港からスムーズに到着できて大変助かりました。次回も必ず利用します。',
    stay: '7泊',
    avatar: 'L',
    avatarColor: '#8B2500',
  },
  {
    id: 6,
    name: '山本 花子',
    country: '🇯🇵 名古屋',
    date: '2025年3月',
    rating: 5,
    title: '記念日旅行に最適な特別な空間',
    text: '結婚記念日に利用しました。昭和レトロな雰囲気がロマンチックで、二人だけの特別な時間を過ごせました。ホストの方が花を飾ってくださっていて感動！細やかな心遣いに感謝です。',
    stay: '2泊',
    avatar: 'H',
    avatarColor: '#c8504a',
  },
];

export default function RecentReviewsSlider() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState<'left' | 'right'>('right');

  const visibleCount = 3;
  const total = reviews.length;

  const goTo = useCallback((index: number, dir: 'left' | 'right') => {
    if (isAnimating) return;
    setDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 300);
  }, [isAnimating]);

  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, 'left');
  }, [current, total, goTo]);

  const next = useCallback(() => {
    goTo((current + 1) % total, 'right');
  }, [current, total, goTo]);

  useEffect(() => {
    const timer = setInterval(() => {
      next();
    }, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const getVisibleReviews = () => {
    const items = [];
    for (let i = 0; i < visibleCount; i++) {
      items.push(reviews[(current + i) % total]);
    }
    return items;
  };

  return (
    <div
      className="mb-10 rounded-2xl overflow-hidden"
      style={{ border: '3px solid #c8a96e', boxShadow: '0 8px 30px rgba(139,37,0,0.15)' }}
    >
      {/* ヘッダー */}
      <div
        className="px-6 py-4 flex items-center justify-between"
        style={{ background: 'linear-gradient(135deg, #3d1f00 0%, #6b3a1f 100%)', borderBottom: '2px solid #c8a96e' }}
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0" style={{ background: 'rgba(200,169,110,0.25)', border: '1.5px solid #c8a96e' }}>
            <i className="ri-star-fill text-sm" style={{ color: '#c8a96e' }}></i>
          </div>
          <div>
            <h3 className="text-sm font-extrabold text-white tracking-wide">直近の予約者レビュー</h3>
            <p className="text-xs" style={{ color: '#c8a96e' }}>Recent Guest Reviews</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {/* 総合評価 */}
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full" style={{ background: 'rgba(200,169,110,0.2)', border: '1px solid #c8a96e' }}>
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map(s => (
                <i key={s} className="ri-star-fill text-xs" style={{ color: '#f5c842' }}></i>
              ))}
            </div>
            <span className="text-xs font-bold text-white">5.0</span>
            <span className="text-xs" style={{ color: '#c8a96e' }}>/ 5.0</span>
          </div>
          {/* ナビゲーションボタン */}
          <div className="flex gap-1.5">
            <button
              onClick={prev}
              className="w-7 h-7 flex items-center justify-center rounded-full transition-all hover:scale-110 cursor-pointer"
              style={{ background: 'rgba(200,169,110,0.2)', border: '1.5px solid #c8a96e', color: '#c8a96e' }}
            >
              <i className="ri-arrow-left-s-line text-sm"></i>
            </button>
            <button
              onClick={next}
              className="w-7 h-7 flex items-center justify-center rounded-full transition-all hover:scale-110 cursor-pointer"
              style={{ background: 'rgba(200,169,110,0.2)', border: '1.5px solid #c8a96e', color: '#c8a96e' }}
            >
              <i className="ri-arrow-right-s-line text-sm"></i>
            </button>
          </div>
        </div>
      </div>

      {/* レビューカード */}
      <div
        className="p-5"
        style={{ background: 'linear-gradient(135deg, #fdf6e3 0%, #f5e6c8 100%)' }}
      >
        <div
          className="grid grid-cols-1 sm:grid-cols-3 gap-4 transition-all duration-300"
          style={{
            opacity: isAnimating ? 0 : 1,
            transform: isAnimating
              ? `translateX(${direction === 'right' ? '-20px' : '20px'})`
              : 'translateX(0)',
          }}
        >
          {getVisibleReviews().map((review) => (
            <div
              key={review.id}
              className="rounded-xl p-4 flex flex-col gap-3 relative"
              style={{
                background: '#fff',
                border: '1.5px solid #e8d5b0',
                boxShadow: '0 2px 12px rgba(139,37,0,0.08)',
              }}
            >
              {/* 引用符 */}
              <div
                className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center rounded-full opacity-20"
                style={{ background: '#8B2500' }}
              >
                <i className="ri-double-quotes-l text-xs" style={{ color: '#8B2500' }}></i>
              </div>

              {/* ユーザー情報 */}
              <div className="flex items-center gap-2.5">
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 font-extrabold text-sm text-white"
                  style={{ background: `linear-gradient(135deg, ${review.avatarColor}, ${review.avatarColor}cc)` }}
                >
                  {review.avatar}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-bold truncate" style={{ color: '#3d1f00' }}>{review.name}</p>
                  <p className="text-xs truncate" style={{ color: '#9a7a50' }}>{review.country}</p>
                </div>
              </div>

              {/* 星評価 */}
              <div className="flex items-center justify-between">
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map(s => (
                    <i key={s} className="ri-star-fill text-xs" style={{ color: s <= review.rating ? '#f5c842' : '#e0d0b0' }}></i>
                  ))}
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-xs px-1.5 py-0.5 rounded-full font-bold" style={{ background: '#fff8e1', border: '1px solid #c8a96e', color: '#8B2500', fontSize: '10px' }}>
                    {review.stay}
                  </span>
                  <span className="text-xs" style={{ color: '#b0956a', fontSize: '10px' }}>{review.date}</span>
                </div>
              </div>

              {/* タイトル */}
              <p className="text-xs font-bold leading-snug" style={{ color: '#3d1f00' }}>
                「{review.title}」
              </p>

              {/* 本文 */}
              <p className="text-xs leading-relaxed line-clamp-4" style={{ color: '#6b4c2a' }}>
                {review.text}
              </p>

              {/* 認証バッジ */}
              <div className="flex items-center gap-1 mt-auto pt-1" style={{ borderTop: '1px dashed #e8d5b0' }}>
                <div className="w-3.5 h-3.5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-verified-badge-fill text-xs" style={{ color: '#4caf50' }}></i>
                </div>
                <span className="text-xs" style={{ color: '#4caf50', fontSize: '10px' }}>宿泊確認済みレビュー</span>
              </div>
            </div>
          ))}
        </div>

        {/* ドットインジケーター */}
        <div className="flex items-center justify-center gap-1.5 mt-4">
          {reviews.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i, i > current ? 'right' : 'left')}
              className="rounded-full transition-all cursor-pointer"
              style={{
                width: i === current ? 20 : 6,
                height: 6,
                background: i === current
                  ? 'linear-gradient(90deg, #8B2500, #c8504a)'
                  : '#c8a96e',
                opacity: i === current ? 1 : 0.5,
              }}
            />
          ))}
        </div>

        {/* 総レビュー数 */}
        <p className="text-center text-xs mt-3" style={{ color: '#9a7a50' }}>
          <i className="ri-chat-quote-line mr-1"></i>
          全 <strong style={{ color: '#8B2500' }}>47件</strong> のレビュー平均 ⭐ 5.0 — Airbnb・直接予約合算
        </p>
      </div>
    </div>
  );
}
